import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { PACK_TYPE_NUMBER } from 'app/utils/constants';
import { useSelector } from 'react-redux';
import {
  ButtonActivatePack,
  ButtonCancelPack,
  ButtonChangePack,
  ButtonReactivatePack,
  ButtonUpgradePack
} from './Buttons';

import styles from './styles.module.scss';

export default function FooterButtons() {
  const {
    user: {
      attributes: { packId, subscriptionRenewCancelDate }
    }
  } = useSelector((state) => state.auth);

  return (
    <Row>
      <Col md={{ span: 9, offset: 3 }} className={styles.container}>
        {getButtonsByPack(packId, subscriptionRenewCancelDate)}
      </Col>
    </Row>
  );
}

const getButtonsByPack = (packId, subscriptionRenewCancelDate) => {
  switch (packId) {
    case PACK_TYPE_NUMBER.WITHOUT:
      return <ButtonActivatePack />;

    case PACK_TYPE_NUMBER.ECOMMERCE:
      if (subscriptionRenewCancelDate) {
        return (
          <>
            <ButtonChangePack />
            <ButtonReactivatePack />
          </>
        );
      }

      return (
        <>
          <ButtonCancelPack />
          <ButtonChangePack primary />
        </>
      );

    case PACK_TYPE_NUMBER.MARKETPLACES:
      if (subscriptionRenewCancelDate) {
        return <ButtonReactivatePack />;
      }

      return <ButtonCancelPack />;

    case PACK_TYPE_NUMBER.B2B:
    default:
      return <ButtonUpgradePack />;
  }
};
